import { FormBuilder } from '@angular/forms';
import {
    AbstractWidgetComponent,
    getFieldFromArray,
    isNotEmpty
} from '../../../utils/util';
import { DataelementApi, EntityApi, LoopBackAuth } from '../../../sdk';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { PushNotificationsService, NotificationsService } from 'angular2-notifications';
import { PlatformApp } from '../../../services/app.service';
@Component({
    selector: 'angulargauge-widget',
    templateUrl: './angualrgauge.component.html',
    styleUrls: ['./angulargauge.component.scss']
})

export class AngularGaugeComponent extends AbstractWidgetComponent implements OnInit, OnDestroy {
    id = 'linechart' + Math.floor((Math.random() * 1000000000000) + 1);
    @Input() title = 'Total Assets';
    ddd = false;
    @Input() widget: any;
    @Input() autorefresh = true;
    _maxV = 100;
    _dataelementid = '58b2ea4c052dae009c136220';
    _basefield = '';
    notifyOptions = PlatformApp.getNotificationOptions();
    constructor(_dataelementApi: DataelementApi, fb: FormBuilder,
        private _NotificationsService: NotificationsService, private _PushNotificationsService: PushNotificationsService,
        _loopBackAuth: LoopBackAuth, _entityApi: EntityApi) {
        super(_dataelementApi, fb, _loopBackAuth, _entityApi);
    }

    ngOnInit() {
        if (this.widget) {
            this._dataelementid = this.widget.dataelement;
            this.ddd = this.widget.ddd ? Boolean(this.widget.ddd) : this.ddd;
            this.autorefresh = this.widget.autorefresh ? Boolean(this.widget.autorefresh) : this.autorefresh;
            this._basefield = this.widget.basefield;
            this._maxV = this.widget.maxvalue;
            if (isNotEmpty(this.widget.filterfields)) {
                this.filter_fields = _.cloneDeep(this.widget.filterfields);
            }
            this.title = this.widget.title;
        }
        this.options = this.createChartConfig();
        this.setChartConfig();
    }

    createChartConfig(dataelement?) {
        let options = {
            'type': 'gauge',
            'theme': 'light',
            'axes': [{
                'axisThickness': 1,
                'axisAlpha': 0.2,
                'tickAlpha': 0.2,
                'valueInterval': 20,
                'bands': [{
                    'color': '#25a5fa',
                    'endValue': this._maxV,
                    'startValue': 0,
                    'innerRadius': '100%',
                    'radius': '90%',
                }],
                'bottomText': '0',
                'bottomTextYOffset': -20,
                'endValue': this._maxV
            }],
            'arrows': [{}]
        };
        if (dataelement && isNotEmpty(dataelement['data'])) {
            if (isNotEmpty(dataelement['fields'])) { // there should be only one output field for metric related dataelement
                let field = this._basefield ? getFieldFromArray(dataelement['fields'], this._basefield) : dataelement['fields'][0];
                if (field) {
                    let value = dataelement['data'][0][field.name];
                    options.arrows[0]['value'] = value;
                    options.axes[0].bottomText = value;
                    if (field.unit) {
                        options.axes[0].bottomText += ' ' + field.unit;
                    }
                    if (this._maxV < value) {
                        this._maxV = value;
                        options.axes[0].endValue = value;
                        options.axes[0].bands[0].endValue = value;
                    }
                }
            }
        }

        console.log('options:-', JSON.stringify(options));
        return options;
    }

    ngOnDestroy() {
        clearInterval(this._timer);
    }

    notify(type, title?, content?, options?) {
        if (!options) options = PlatformApp.getNotificationOptions();
        if (!options.id) options.id = type + '-' + title + '_' + content;
        switch (type) {
            case 'success': this._NotificationsService.success(title, content, options); break;
            case 'alert': this._NotificationsService.alert(title, content, options); break;
            case 'error': this._NotificationsService.error(title, content, options); break;
            case 'info': this._NotificationsService.info(title, content, options); break;
            case 'bare': this._NotificationsService.bare(title, content, options); break;
            default: this._NotificationsService.info(title, content, options);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/angulargauge/angulargauge.component.ts